let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("6XoCv"), load("3kUQf"), load("ffEVr"), load("borwc")]).then(() => parcelRequire('jhdHU'));